import React from "react";
import {BrowserRouter as Router} from "react-router-dom";
import PreLoader from './core/components/core/Layout/PreLoader/PreLoader';
import CoreRoutes from './core/routes/CoreRoutes';
import {createStore} from 'redux';
import {Provider} from 'react-redux';
import coreReducer from "./core/reducers/core/coreReducer";
import ApplicationRoutes from "./application/routes/Routes";
import { loadState, saveState } from "./core/store/SessionStore";

const store = createStore(coreReducer,loadState());

store.subscribe(() => {
  saveState(store.getState());
});


function App() {
  return (
    <Provider store={store}>
      <Router>
          <PreLoader />
          <CoreRoutes/>
          <ApplicationRoutes />
      </Router>
      </Provider>
  );
}

export default App;
